import { GetStaticProps, InferGetStaticPropsType } from "next";

import { AppShell } from "@chef/feature-app-shell";
import { ISustainability, getSustainabilityData } from "../queries";
import { ContentComponent } from "../components";
import { SanityQuery } from "../types";
import { useSustainabilityData } from "../hooks";

export const SustainabilityPage = (
  props: InferGetStaticPropsType<typeof getStaticProps>,
) => {
  const [sustainability] = useSustainabilityData(props.sustainability);

  if (!sustainability) {
    return null;
  }

  return (
    <ContentComponent block={sustainability.content}>
      {({ children, title, description, imageUrl, index }) => (
        <AppShell
          title={title}
          description={description}
          image={imageUrl}
          index={index}
        >
          <AppShell.Meta />
          <AppShell.Header />
          <AppShell.DiscountBanner />
          <AppShell.Main noPadding>{children}</AppShell.Main>
          <AppShell.Footer />
        </AppShell>
      )}
    </ContentComponent>
  );
};

export const getStaticProps: GetStaticProps<
  {
    draftMode: boolean;
    sustainability: ISustainability;
  },
  SanityQuery
> = async ({ draftMode = false }) => {
  const sustainability = await getSustainabilityData(null, {
    preview: draftMode,
  });

  if (!sustainability || !sustainability.content) {
    return {
      notFound: true,
      revalidate: 600,
    };
  }

  return {
    props: {
      draftMode,
      sustainability,
    },
    revalidate: 600,
  };
};
